/** @type {string} */
const modalComponent = "Modal";
export default modalComponent;
